import Header from './components/Header';
import HeroSection from './components/HeroSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <CommentsSection />
        <ContactSection />
        <MediaSection />
        <RankingSection />
        <AppSection />
        <CarouselSection />
        <UpdatesSection />
        <CardsSection />
        <FeaturesSection />
        <TopicsSection />
        <AboutSection />
        <IndexSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}